import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colors from '../../../../styles/colors';
import moment from 'moment';
import ModalDialog, { SaveButton, CloseButton } from '../../../../components/ModalDialog';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import Loading from '../../../../components/Loading';
import { isNull } from 'lodash';

class RegisteredOnButton extends Component {
  constructor(props) {
    super(props);

    const {
      date_subscribed: dateSubscribed = moment.unix(),
      date_subscribed_bak: dateSubscribedBak = null,
    } = props.subscription || {};

    this.state = {
      dateSubscribed,
      dateSubscribedBak,
      saving: false,
      showModal: false,
      showDropdown: false,
      pickedDate: moment.unix(dateSubscribed).startOf('day'),
      processing: false,
    };
  };

  toggleModal = () => {
    const { showModal = false } = this.state || {};
    this.setState({
      showModal: !showModal,
    });
  };

  toggleDropdownMenu = () => {
    const { showDropdown = false } = this.state || {};
    this.setState({
      showDropdown: !showDropdown,
    });
  };

  saveDates = ({ revertBak = false }) => {
    const { dateSubscribed, dateSubscribedBak } = this.state;

    const unixDate = revertBak ? dateSubscribedBak : this.getSelectedOn();
    this.setState({ processing: true }, async () => {
      const success = await this.props.onSaveSelected({ unixDate, revertBak });
      const newStateData = success
        ? {
            dateSubscribed: unixDate,
            ...( revertBak ? { dateSubscribedBak: null } 
              : isNull(dateSubscribedBak) ? { dateSubscribedBak: dateSubscribed }
              : {} 
            ),
          }
        : { pickedDate: moment.unix(dateSubscribed).startOf('day') }; // cancel
      this.setState({ ...newStateData, processing: false}, this.toggleModal);
    });
  };

  onBak = () => {
    this.saveDates({ revertBak: true });
  };

  onSave = () => {
    this.saveDates({ revertBak: false });
  };

  onCancel = () => {
    const { dateSubscribed } = this.state;
    this.setState({ pickedDate: moment.unix(dateSubscribed).startOf('day') }, this.toggleModal);
  };

  onDatePick = pickedDate => {
    if (pickedDate.unix) {
      this.setState({
        pickedDate: moment(pickedDate).startOf('day'),
      });
    }
  };

  getSelectedOn = () => {
    const { pickedDate } = this.state;
    return moment(pickedDate).unix();
    // return moment(pickedDate).add(5, 'hour').unix(); // ???
  };

  openDialog = evt => {
    evt.preventDefault();
    this.toggleDropdownMenu();
    this.toggleModal();
  };

  render() {
    const { disabled } = this.props;
    const { showModal, pickedDate, processing, dateSubscribedBak = null } = this.state;

    const isInvalid = moment.unix(this.getSelectedOn()).isAfter();
    const errormsg = isInvalid ? 'The date cannot be in the future.' : '';

    const noBakButton = isNull(dateSubscribedBak);
    const bakTitle = noBakButton 
      ? '' 
      : `restore original date ${moment.unix(dateSubscribedBak).format('YYYY-MM-DD HH:mm')}`;

    return (
      <React.Fragment>
        <div className="btn-group">
          <SelectDateButton
            noBak={noBakButton}
            className="btn dropdown-toggle"
            onClick={this.openDialog}
            disabled={disabled}>
            {moment.unix(this.getSelectedOn()).format('YYYY-MM-DD')}
          </SelectDateButton>
        </div>

        <ModalDialog
          title="Pick Date"
          open={showModal}
          bodyStyle={{ overflowY: 'auto' }}
          contentStyle={{
            width: 350,
            maxWidth: 'none',
            transform: 'translate(0px, 15px)',
          }}
          actions={[
            ...(noBakButton ? [] : [
              <BakButton
                className="btn text-medium margin-two-right naked"
                datatoggle="tooltip"
                dataplacement="top"
                title={bakTitle}
                disabled={processing}
                onClick={this.onBak}>
                BAK
              </BakButton>,
            ]),
            <CloseButton
              className="btn text-medium margin-two-right naked"
              disabled={processing}
              onClick={this.onCancel}>
              Cancel
            </CloseButton>,
            <SaveButton 
              className="btn text-medium"
              disabled={isInvalid || processing}
              onClick={this.onSave}>
              Save
            </SaveButton>,
          ]}>
          {processing && (
            <Loading align="center" size={40} fontSize={1.6} text="Saving..." />
          )}
          {!processing && (
            <PickerWrapper>
              <DatePickerWrapper errored={isInvalid}>
                <div className="text-medium font-weight-600">Date</div>
                <span className="error-txt">{errormsg}</span>
                <DateTime
                  open={true}
                  value={pickedDate}
                  timeFormat={false}
                  onChange={this.onDatePick}
                />
              </DatePickerWrapper>
            </PickerWrapper>
          )}
        </ModalDialog>
      </React.Fragment>
    );
  }
}

const PickerWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const DatePickerWrapper = styled.div`
  width: 300px;
  min-width: 300px;
  min-height: 310px;
  position: relative;

  font-size: 14px;
  color: #474747;

  .rdt {
    input {
      ${props => (props.errored ? 'border: 1px solid #E57373 !important;' : '')}
    }

    .rdtPicker {
      width: 100%;
      td,
      th {
        height: 30px;
      }
    }
  }

  .error-txt {
    position: absolute;
    top: 55px;
    left: 1px;
    font-size: 1.3rem;
    color: #f44336;
  }
`;

const BakButton = styled(CloseButton)`
  padding: 8px 20px;
`;

const SelectDateButton = styled.button`
  ${props => (props.noBak ? 'font-weight: 100 !important;' : 'font-weight: 700 !important;')},
`;

RegisteredOnButton.propTypes = {
  subscription: PropTypes.object,
  disabled: PropTypes.bool,
  onSaveSelected: PropTypes.func,
};

RegisteredOnButton.defaultProps = {
  subscription: {},
  disabled: false,
  onSaveSelected: () => {},
};

export default RegisteredOnButton;
